'use client';
function conditionalPropType(predicateFun, truthyValidator, falsyValidator) {
    return function conditionalValidator(props, propName, componentName, location, propFullName, ...args) {
        const conditionValue = predicateFun(props, propName, componentName, location, propFullName);
        if (conditionValue) {
            return truthyValidator(props, propName, componentName, location, propFullName, ...args);
        }
        return falsyValidator(props, propName, componentName, location, propFullName, ...args);
    };
}

export { conditionalPropType };
